import { type IAction } from '../../@types';
import { SET_COMPANY } from '../types/company';

export const setCompany = (payload: any): IAction<any> => ({
  type: SET_COMPANY,
  payload,
});
